import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  'library.update.error': {
    defaultMessage: 'Failed to update library',
    id: 'library.update.error'
  },
  'library.update.pageTitle': {
    defaultMessage: 'Update Library',
    id: 'library.update.pageTitle'
  },
  'library.update.success': {
    defaultMessage: 'Updated library',
    id: 'library.update.success'
  }
});
